import { useStore } from '@xyflow/react'
import { zoomPercentLabel } from './smoothZoom'

/**
 * How far in the canvas is zoomed, read straight off the camera rather than
 * tracked alongside it: the zoom buttons, the fit, the minimap and the wheel
 * all move the same transform, so all four keep this number honest.
 */
export default function ZoomReadout() {
  const zoom = useStore(state => state.transform[2])
  const label = zoomPercentLabel(zoom)

  return (
    <div
      data-testid="chart-zoom-readout"
      aria-label={`Zoom ${label}`}
      className="absolute left-[15px] bottom-[143px] z-10 px-2 py-1 rounded-button bg-white border border-stone shadow-card text-xs font-semibold text-text-primary tabular-nums select-none pointer-events-none"
    >
      {label}
    </div>
  )
}
